import request from '@/common/request'
// --------------------报表管理 --销售汇总表----------------------------------
// 汇总列表
export const getReportGroupList = (params) => {
  return request.get('/report/medicine/list', { params })
}
// 导出
export const getExportCountRecipe = (params) => {
  return request.get('/report/exportCountRecipeGroupByMedicine', { params })
}
// --------------------------报表管理 --销售明细表-------------------------------
// 明细列表
export const getMedicineSaleList = (params) => {
  return request.get('/report/medicine/detail', { params })
}
// 导出
export const getExportCountMedicineSale = (params) => {
  return request.get('/report/exportCountMedicineSaleDetail', { params })
}
// 获取经办人列表
export const getSysUserWithFunc = (params) => {
  return request.get('/report/getSysUserWithFunc', { params })
}
// 查询开方医生列表
export const getRecipeDoctor = (params) => {
  return request.get('/home/getDoctorList ', { params })
}
// ---------------------------报表管理 --整体运营一览表列表-------------------------
// 整体运营一览表列表
export const getCountRecipeGroupByHosp = (params) => {
  return request.get('/report/operating/list', { params })
}
// 获取县乡村
export const getCountDoctorHosp = (params) => {
  return request.get('/home/countDoctorHosp', { params })
}
// 获取机构列表
export const getDoctorHosp = (params) => {
  return request.get('/home/getHospList', { params })
}
// 机构绩效汇总表
export const getCountRecipeGroupByDoctor = (params) => {
  return request.get('/report/operating/hospList', { params })
}
// 单个医生绩效
export const getCountAchievementsOneDoctor = (params) => {
  return request.get('/report/operating/doctorRecipeCount', { params })
}
// 单个医生开方明细表
export const getCountGetMedicinalRecipeBy = (params) => {
  return request.get('/report/operating/recipeList', { params })
}
// 处方药材明细
export const getMedicinalRecipeDetailList = (params) => {
  return request.get('/report/operating/getMedicinalRecipeDetailList', { params })
}
// ---------------------报表管理 --药房销售汇总表-------------------------
// 药房销售汇总表
export const getCountRecipeGroupBySysStore = (params) => {
  return request.get('/report/medicine/count', { params })
}
// 财务汇总报表
export const getSysStoreList = (params) => {
  return request.get('/report/getSysStoreList', { params })
}
// ---------------------报表管理 --财务汇总报表---------------------------
// 财务汇总报表
export const getReportStatistic = (params) => {
  return request.get('/report/reportStatistic', { params })
}
